import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";

import Footer from "./Footer";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { logo } from "assets/images";
import { Loading } from "components/Loading";
import Emitter from "utility/emitter";
import AzureAD, { IAzureADFunctionProps } from "react-aad-msal";
import { azureAuthProvider } from "utility/authProvider";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import { SHOW_LOADER } from "utility/emitterEvents";
import { UserType } from "utility/enums/user-type";

const Layout: React.FC = () => {
	const userMenuAccessRights = useSelector(
		(state: RootState) => state.authState.userMenuAccessRights
	);
	const loggedInUserDetail = useSelector(
		(state: RootState) =>
			state.authState.userDetails && state.authState.userDetails
	); // fetch logged in user details from redux

	const [loading, setLoading] = React.useState(false);

	useEffect(() => {
		Emitter.on(SHOW_LOADER, (loading: boolean) => {
			setLoading(loading);
			if (loading) {
				document.body.classList.add("overflow-hidden");
			} else {
				document.body.classList.remove("overflow-hidden");
			}
		});
		return () => {
			setLoading(false);
			Emitter.off(SHOW_LOADER, undefined);
		};
	}, []);

	return (
		<>
			<AzureAD provider={azureAuthProvider}>
				{({ accountInfo }: IAzureADFunctionProps) => {
					return accountInfo &&
						loggedInUserDetail.userTypeId !== UserType.External ? (
						!userMenuAccessRights.length && <Loading />
					) : (
						<></>
					);
				}}
			</AzureAD>
			{loading && <Loading />}
			<section className="main-content">
				<Header />
				<div className="page-content">
					<Sidebar />
					<div className="page-inner">
						<Outlet />
					</div>
					<Footer logoUrl={logo} isForLayout />
				</div>
			</section>
		</>
	);
};

export default Layout;
